<template>
  <div class="bigbox" >
      <img-app :style="backImg" :contactTitle="contact.name" :contactList="contact.contactlist" ></img-app>
      <div class="main">
          <span class="block zhaopin_title fontWeight ft16">{{oData.jobName}}</span>
          <div class="zhaopin_exper">
            <span class="pull-left"><img src="static/images/zhaopin_exper01.png" alt="">{{oData.jobTime}}</span>
            <span class="pull-left"><img src="static/images/zhaopin_exper02.png" alt="">{{oData.education}}</span>
            <span class="pull-left"><img src="static/images/zhaopin_exper03.png" alt="">{{oData.require}}</span>
          </div>
          <div class="zhaopin_duty">
            <span class="block fontWeight">岗位职责：{{this.info}}</span>
            <!-- <ul>
              <li>1、构建基于云技术架构的开发平台，负责云计算应用框架的设计和开发领导工作。</li>
              <li>2、能独立完成软件项目模块的设计、编码实现、测试。</li>
              <li>3、参与相关质量活动，确保软件设计及实现工作按时保质完成。</li>
              <li>4、负责技术文档的编写和维护。</li>
            </ul> -->
            <ol>
              <li v-for="item in oData.duty">{{item.list}}</li>
            </ol>
          </div>
          <div class="zhaopin_duty">
            <span class="block fontWeight">任职要求：</span>
            <!-- <ul>
              <li>1、计算机相关专业的本科和研究生；具有5年以上软件研发经验，具备出色的系统分析能力和技术攻关能力；</li>
              <li>2、精通分布式系统设计原理，熟悉Oralce、MYSQL等大型数据库，有分布式数据库设计经验，有数据库集群设计经验，熟悉读写分离、分库分表，并有对应实际项目的开发设计经验； 熟悉Java语言，精通网络编程并有高并发系统的设计开发经验 ；</li>
              <li>3、精通大规模系统的Java EE架构技术，熟练掌握常见开源框架和技术，如Ibatis、Struts2、Spring、ActiveMQ、Jquery、Ajax、memcached、hibernate等，熟练使用Eclipse开发工具，对框架本身有过开发或重构者可优先考虑；</li>
              <li>4、有mysql分库分表系统重构经验优先；具备海量数据高性能分析及处理的成熟经验者优先；</li>
              <li>5、责任心强、学习能力强，优秀的沟通能力和强烈探索精神；可承受较大压力，有责任感，较强的沟通协调能力，具有团队合作精神,能带领团队进行应用开发项目的管理和执行。</li>
            </ul> -->
            <ol>
              <li v-for="item in oData.requirement">{{item.list}}</li>
            </ol>
          </div>
          <div class="zhaopin_connect">
            <span class="block fontWeight">联系方式：</span>
            <div class="zhaopin_connect-ways"><img src="static/images/zhaopin_tel.png" alt="">0571-89978771<br>
            <img src="static/images/zhaopin_email.png" alt="">hr@smarthse.cn<br>
            <img src="static/images/zhaopin_location.png" alt="">浙江省·杭州市·江干区·水墩新路8号-5楼</div>
          </div>
      </div>
    </div>
</template>

<script>
 import imgApp from '@/components/common/imgApp.vue'; 
 import pagination from '@/components/common/pagination.vue'; 
 import bus from '@/assets/js/bus'
export default {
  name: 'talent_zhaopin-detail',
  props:{
    info:Number
  },
  data () {
    return {
      backImg:{
        background:'url(static/images/recruit-bg.jpg) no-repeat center 68px'
      },
      contact:{
        name:'人才招聘',
        contactlist:[{listTitle:"站内招聘"},{listTitle:"站外招聘"}]
      },
      current_id:null,
      oData:{
        /*jobName:'高级JAVA开发工程师',
        jobTime:'1-3年工作经验',
        education:'本科',
        require:'3人',
        duty:[
        {list:'构建基于云技术架构的开发平台，负责云计算应用框架的设计和开发领导工作。'},
        {list:'能独立完成软件项目模块的设计、编码实现、测试。'},
        {list:'参与相关质量活动，确保软件设计及实现工作按时保质完成。'},
        {list:'负责技术文档的编写和维护。'}],
        requirement:[
        {list:'计算机相关专业的本科和研究生；具有5年以上软件研发经验，具备出色的系统分析能力和技术攻关能力；'},
        {list:'精通分布式系统设计原理，熟悉Oralce、MYSQL等大型数据库，有分布式数据库设计经验，有数据库集群设计经验，熟悉读写分离、分库分表，并有对应实际项目的开发设计经验； 熟悉Java语言，精通网络编程并有高并发系统的设计开发经验 ；'},
        {list:'有mysql分库分表系统重构经验优先；具备海量数据高性能分析及处理的成熟经验者优先；'},
        {list:'责任心强、学习能力强，优秀的沟通能力和强烈探索精神；可承受较大压力，有责任感，较强的沟通协调能力，具有团队合作精神,能带领团队进行应用开发项目的管理和执行。'}
        ]*/
      },
      testData:[
        {
          recruit_id:1,
          content:{
            jobName:'销售顾问（销售软件系统）',
            jobTime:'0-3年工作经验',
            education:'本科',
            require:'若干人',
            duty:[
              {list:'负责本公司旗下互联网产品的客户拓展工作：通过公司提供的资源或自行挖掘寻找目标客户，针对目标客户进行业务拓展；'},
              {list:'了解和发掘客户的核心需求和购买意愿，介绍自己产品的优势和特点。'},
              {list:'对客户提供专业咨询，主动关注客户成效；'},
              {list:'收集分析客户信息，并结合客户成效给以公司反馈。'}
            ],
            requirement:[
              {list:'本科以上学历；'},
              {list:'拥有良好的沟通及表达能力，学习能力强；'},
              {list:'充满活力、积极上进，对互联网产品销售工作具有浓厚兴趣和自信心；'},
              {list:'有1年以上相关销售经验，有较强的业务能力及优秀的销售业绩者；无销售经验但不满足于现状，勇于挑战高薪者；'},
              {list:'吃客耐劳、承压能力强、责任感强，有良好的团队协作精神；'},
              {list:'熟悉互联网服务类产品特性和销售特征者优先。'}
            ]
          }
        },
        {
          recruit_id:2,
          content:{
            jobName:'软件测试主管',
            jobTime:'3-5年工作经验',
            education:'本科',
            require:'1人',
            duty:[
                {list:'根据开发项目、产品开发文档和测试需求，编制测试方案、测试用例和制定测试计划，分配测试资源和测试任务，组织实施测试，控制测试进度，调整测试计划；'},
                {list:'组织设计并搭建测试环境；'},
                {list:'组织完成对产品的功能测试、集成测试与系统测试，对测试结果负责；'},
                {list:'配合专业技术部和运维部门进行Bug验证、汇总并提交Bug管理系统进行跟踪，并对bug原因进行分析和汇总；'},
                {list:'提出对软件改进的要求并评估改进方案；协同开发部门实施改进方案，并评估改进结果。'}
            ],
            requirement:[
              {list:'大学本科以上学历，计算机或相关专业毕业；'},
              {list:'有软件开发经验，需3年以上的软件测试经验及1年以上软件测试管理经验（有自动化实践经验、能编写脚本不论语言的管理经验可欠缺）；'},
              {list:'熟悉常用测试方法及技巧，理解测试流程，有web测试和功能测试、集成测试以及系统测试经验；能将自动化测试落实（可和组员共同研究成长）；'},
              {list:'具有较强的结果导向型思维，善于发现和分析问题，且有很强的质量控制意识；'},
              {list:'沟通能力强，良好的进取精神和很强的责任心；'},
              {list:'熟练使用常用软件测试工具，有loadrunner使用经验者优先；'},
              {list:'善管理/乐意承担管理和对外沟通职责，能提升组员能力（现有3位测试），纯技术型的暂不考虑。'}
            ]
          }
        },
        {
          recruit_id:3,
          content:{
            jobName:'产品专员/助理（负责管理类软件产品设计）',
            jobTime:'1-3年工作经验',
            education:'本科',
            require:'若干人',
            duty:[
                {list:'负责非专业性产品的设计（即除EHS类管理软件外各项目产品的设计），包括平台管理系统、 运营后台管理系统、 健康顾问管理系统及其他相关软件的功能设计和需求提出，按照要求编写需求说明文档及其他相关说明，配合软件开发，协助软件测试，关注软件功能实现情况；'},
                {list:'负责收集和主动挖掘各方面的产品需求，持续维护改进软件功能；'},
                {list:'跟踪各产品系统的前沿法律法规、要求、技术、资料，并及时根据前沿信息维护改进相关软件；'},
                {list:'参与用户相关技术咨询答疑；'},
                {list:'参与收集和梳理相关规定标准，并核实有效性；'},
                {list:'上级安排的其他工作。'}
            ],
            requirement:[
              {list:'本科以上学历，2年（含）以上产品设计相关工作经验；'},
              {list:'好学勤勉，主动积极，认同公司团队价值观，有志于管理信息化事业；'},
              {list:'极强的执行能力，有团队合作精神，顾全大局，有责任心、进取心；'},
              {list:'有抗压和组织规划能力，能作为项目需求主负责人承担某款软件产品的功能设计工作；'},
              {list:'有良好的语言沟通能力和学习能力，文字功底扎实，编辑能力强，能熟练使用电脑办公软件。'}
              
            ]
          }
        },
        {
          recruit_id:4,
          content:{
            jobName:'EHS专业技术工程师（环保方向）',
            jobTime:'3-5年工作经验',
            education:'本科',
            require:'1人',
            duty:[
                {list:'负责EHS管理软件及其他相关软件的功能设计和需求提出，按照要求编写需求说明文档及其他相关说明，配合软件开发，协助软件测试，关注软件功能实现情况；'},
                {list:'负责收集和主动挖掘各方面的产品需求，持续维护改进软件功能；'},
                {list:'跟踪EHS前沿法律法规、要求、技术、资料，并及时根据前沿信息维护改进相关软件；'},
                {list:'参与用户EHS相关技术咨询答疑；'},
                {list:'参与收集和梳理EHS相关法律法规标准，并核实有效性；'},
                {list:'上级安排的其他工作。'}
            ],
            requirement:[
              {list:'本科以上学历，3年（含）以上安全/环保/放辐射相关工作经验，熟悉安全/环保/放辐射法律法规和企业安全/环保/放辐射管理要求；熟悉排污许可证（针对环保）取证过程以及要求者优先考虑；'},
              {list:'文字功底扎实，好学勤勉，认同公司团队价值观，有志于EHS管理信息化事业；'},
              {list:'执行力强，耐心细致；'},
              {list:'有团队合作精神，顾全大局，有责任心、进取心；'},
              {list:'有良好的语言沟通能力和学习能力，能熟练使用电脑办公软件。'}
              
            ]
          }
        },
        {
          recruit_id:5,
          content:{
            jobName:'软件UI设计实习',
            jobTime:'0-1年工作经验',
            education:'本科',
            require:'1人',
            duty:[
                {list:'本职位是为公司培养自身发展所需人才而设立，旨在通过实习挑选优秀人才进入公司团队中；'},
                {list:'实习内容含基础学习和项目实践，由公司开发人员提供技术和经验指导。'},
                {list:'根据各种相关需求，对产品的整体美术风格、交互设计、界面结构、操作流程等做出设计；'},
                {list:'负责项目中各种交互界面、图标、LOGO、按钮等相关元素的设计；'},
                {list:'负责软件的风格、色彩、布局、图片、图标等设计工作；'},
                {list:'负责公司软件界面的设计及美观优化。'}
            ],
            requirement:[
              {list:'全日制本科及以上学历，美术、平面设计相关专业毕业，优秀的视觉设计能力，对互联网产品的设计有一定的理解；'},
              {list:'能够独立完成的项目中的设计；'},
              {list:'能根据项目需求构建软件界面布局、完成app界面设计及微信端页面设计；'},
              {list:'精通设计软件，能熟练使用 Photoshop、Illustrator、Fireworks、 CorelDRAW等软件；'},
              {list:'能独立完成海报设计、名片设计、宣传册设计等平面宣传设计；'},
              {list:'对OA信息管理系统有一定了解，有过这类工作经验或项目经验者优先；'},
              {list:'善管理/对前端规范有一定了解的优先；'},
              {list:'善管理/简历需附带个人作品集。'}
            ]
          }
        },
        {
          recruit_id:6,
          content:{
            jobName:'客服专员',
            jobTime:'0-2年工作经验',
            education:'本科',
            require:'若干人',
            duty:[
                {list:'协助客户培训工作，独立负责/和组员共同负责客户培训事项（培训软件系统使用，提供非技术类指导与支持，频率不高）；'},
                {list:'负责收集和反馈客户在产品使用过程中提出意见和建议；'},
                {list:'客户使用指导，首次开通指导和一周后初始化后的指导及回访；'},
                {list:'公众号文章编辑，日常内容的撰写、推广和运营，提高关注度；公众号客服响应，24小时留言处理，在线客服回复；'},
                {list:'上级安排的其他工作。'}
            ],
            requirement:[
              {list:'计算机相关/语言类/管理类专业，本科毕业；有客服/培训经验者优先；'},
              {list:'此岗位需出差（频率不定），外出对大客户提供培训和使用指导，其他时间在办公室与客户沟通、反馈；'},
              {list:'思维活跃，语言及文字表达能力强，善于沟通；'},
              {list:'擅长PPT/视频制作；有良好的理解和学习能力；'},
              {list:'好学勤勉，认同公司团队价值观，愿意致力于EHS管理信息化事业；'},
              {list:'极强的执行能力，有团队合作精神，顾全大局，有责任心、耐心。'}
            ]
          }
        },
        {
          recruit_id:7,
          content:{
            jobName:'数据分析工程师（实习）',
            jobTime:'0-1年工作经验',
            education:'本科',
            require:'1人',
            duty:[
                {list:'本职位是为公司培养自身发展所需人才而设立，旨在通过实习挑选优秀人才进入公司团队中；'},
                {list:'实习内容含基础学习和项目实践，由公司开发人员提供技术和经验指导。'},
                {list:'掌握图表设计原则，负责运用图表有效表达数据分析结果，并按照要求编写相关需求文档，配合软件开发，协助软件测试；'},
                {list:'构建业务分析体系，帮助确定各项业务数据的分析指标；'},
                {list:'负责对产品开发过程使用到的各种信息、资料（如，法律法规、案例文件、数据信息等）进行分类、整理；'},
                {list:'负责用户行为数据分析，并通过监控及分析推动产品改进，运营调整；'},
                {list:'负责用户数据的挖掘并形成分析报告；'},
                {list:'上级安排的其他工作。'},
            ],
            requirement:[
              {list:'统计学、应用数学、计算机等本科相关专业，对数字敏感，有很强的数字分析能力，同时有较强的文字表达能力；'},
              {list:'具备Python、R、Excel、JAVA等语言、软件进行数据处理的能力；'},
              {list:'熟练使用可视化工具展示数据，如百度ECHARTS；'},
              {list:'掌握常用的SQL语句，具备数据库（如MYSQL）使用经验，熟练运用正则表达式等；'},
              {list:'掌握机器学习相关理论，并具有建模经验者的优先；'},
              {list:'学习适应能力强，积极主动，做事认真、细心、有条理，有较强的抗压能力和责任感；'},
              {list:'执行力强，同时具有团队合作的精神。'}
            ]
          }
        },
        {
          recruit_id:8,
          content:{
            jobName:'Java开发工程师',
            jobTime:'2年工作经验',
            education:'本科',
            require:'2人',

            duty:[
                {list:'负责产品的新增功能的开发、需求变更、系统BUG等引起的原有程序调整；'},
                {list:'负责产品实施地区的技术维护工作；'},
                {list:'负责产品的需求调研、本地化设计、开发、实施以及培训工作；'},
                {list:'负责软件系统功能设计文档和模块设计文档的编写；'}
            ],
            requirement:[
              {list:'计算机相关，本科及以上；'},
              {list:'具有2年左右及以上java软件开发工作经验；'},
              {list:'熟悉Struts、Spring、Mybatis等主流开源框架；'},
              {list:'熟悉掌握SQL语句,能进行Oracle、mysql数据库开发和使用；'},
              {list:'熟悉Windows和Linux环境下Jboss、Tomcat的安装部署。'}
              
            ]
          }
        },
        {
          recruit_id:9,
          content:{
            jobName:'高级JAVA开发工程师',
            jobTime:'3-5年工作经验',
            education:'本科',
            require:'1人',
            duty:[
                {list:'构建基于云技术架构的软件开发环境，负责软件架构的设计和开发领导工作；'},
                {list:'能独立完成软件项目模块的设计、编码实现、测试。'},
                {list:'参与相关质量活动，确保软件设计及实现工作按时保质完成。'},
                {list:'负责技术文档的编写和维护。'}
            ],
            requirement:[
              {list:'计算机相关专业的本科和研究生；具有5年以上软件研发经验，具备出色的系统分析能力和技术攻关能力；'},
              {list:'精通分布式系统设计原理，熟悉Oralce、MYSQL等大型数据库，有分布式数据库设计经验，有数据库集群设计经验，熟悉读写分离、分库分表，并有对应实际项目的开发设计经验； 熟悉Java语言，精通网络编程并有高并发系统的设计开发经验 ；'},
              {list:'精通大规模系统的Java EE架构技术，熟练掌握常见开源框架和技术，如mybatis、Struts2、SpringMVC、ActiveMQ、Jquery、Ajax、memcached、hibernate等，熟练使用Eclipse开发工具，对框架本身有过开发或重构者可优先考虑；'},
              {list:'有mysql分库分表系统重构经验优先；具备海量数据高性能分析及处理的成熟经验者优先；'},
              {list:'责任心强、学习能力强，优秀的沟通能力和强烈探索精神；可承受较大压力，有责任感，较强的沟通协调能力，具有团队合作精神,能带领团队进行应用开发项目的管理和执行。'}
            ]
          }
        },
        {
          recruit_id:10,
          content:{
            jobName:'Web前端开发工程师（H5+JS+CSS）',
            jobTime:'2年工作经验',
            education:'本科',
            require:'1人',
            duty:[
                {list:'参与产品需求、研发设计的相关讨论，从前端设计角度提升产品使用性和美观度的要求；'},
                {list:'负责产品的前端开发工作，实现产品所需的交互效果；'},
                {list:'与后台技术开发保持良好的沟通，完成具体的开发工作。'}
            ],
            requirement:[
              {list:'计算机相关专业，本科及以上'},
              {list:'具有2-3年及以上前端开发工作经验，自我要求高，执行力强；'},
              {list:'熟练掌握使用JavaScript、html / html5 、css / css3、Ajax等前端开发技术，熟悉W3C标准；'},
              {list:'熟练使用Web开发框架（jQuery、jQuery moblie、bootstrap、Zepto.echart.js等常用框架）；'},
              {list:'具有良好的前端设计感；'},
              {list:'熟练react.js、angular.js 、require.js、node.js，有手机端开发经验者优先。'}
            ]
          }
        },
      ]
    }
  },
  methods:{
   pagechange(currentPage){//当点击时，当前页数传到后台，后台返回相应的页数的数据？
      console.log(currentPage)
   },
   onScroll(){
    bus.$emit('navChange',0); 
   }
  },
  components:{
    "img-app":imgApp,
    "pagination":pagination,
    
  },
  beforeCreate(){
    bus.$emit('NoshowAnimate',this.flase)
  },
  created(){
    console.log(this.$route.params.name)
    this.current_id=this.$route.params.id;
    this.testData.forEach((item,index,arr)=>{
      //console.log(item.newsid)
      if(this.current_id==item.recruit_id){
        this.oData=item.content;
      }
    })
  },
  mounted: function () {
    this.$nextTick(function () {
      window.addEventListener('scroll', this.onScroll)
    })
  },
  destroyed(){
      window.removeEventListener('scroll', this.onScroll);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main{
  width: 1172px;
  margin:4px auto 0;
  padding-left: 200px;
  color:#18191a;
}
.zhaopin_title{
  padding-top: 75px;
  padding-bottom: 38px;

}
.zhaopin_exper span{
  width: 203px;
  line-height: 24px;
}
.zhaopin_exper span>img{
  padding-right: 15px;
}


.zhaopin_duty{
  margin-top: 60px;
  margin-bottom: 38px;
}
.zhaopin_duty>span{
  color:#18191a;
  padding-bottom: 12px;
}
.zhaopin_duty>ol{
  color:#545759;
  line-height: 32px;
  padding-left: 20px;
}
.zhaopin_duty>ol li{

list-style: decimal ;
}
.zhaopin_duty>ul{
  color:#545759;
  line-height: 32px;
}
.zhaopin_connect-ways{
  margin-top: 24px;
  line-height: 24px;
  padding-bottom: 90px;
}
.zhaopin_connect-ways img{
  margin-bottom: 16px;
  padding-right: 11px;
}

@media (max-width: 1240px){
  .main{
      width: 100%;
      padding-left:24%;
      padding-right: 6%;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/talent_zhaopinDetail.vue